import http, { expandURI } from '@/utils/ajax'
import { MYSR_INIT_LOADING, MYSR_INIT_SUCCESS, MYSR_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'

const state = {
  mySalesRevenue: {
    init: 0,
    menu: {},
    revenue: null,
    lastUpdated: null,
    scope: null,
    info: null,
    appIds: []
  }
}

const getters = {

}

const actions = {
  async initMySalesRevenue({ commit, state }, data) {
    commit(MYSR_INIT_LOADING)
    const apiUrl = state.permitWidgets.mySalesRevenue
    if (apiUrl) {
      try {
        let params = {
          from: formatDisplayDateTime2(data.from),
          to: formatDisplayDateTime2(data.to)
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)
        Object.assign(data, {
          menu: menu,
          revenue: result.data.revenue,
          info: result.data.info,
          appIds: result.data.appIds
        })
        commit(MYSR_INIT_SUCCESS, data)
      } catch (error) {
        commit(MYSR_INIT_FAIL)
      }
    } else {
      commit(MYSR_INIT_FAIL)
    }
  }
}

const mutations = {
  [MYSR_INIT_LOADING](state) {
    state.mySalesRevenue.init = 0
  },
  [MYSR_INIT_SUCCESS](state, data) {
    const { mySalesRevenue } = state
    mySalesRevenue.menu = data.menu
    mySalesRevenue.init = 1
    mySalesRevenue.lastUpdated = new Date()
    mySalesRevenue.scope = data.scope
    mySalesRevenue.revenue = data.revenue
    mySalesRevenue.info = data.info
    mySalesRevenue.appIds = data.appIds
  },
  [MYSR_INIT_FAIL](state) {
    state.mySalesRevenue.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
